import React from "react";
import { connect } from 'react-redux';

import { Row, Col, Button, } from "reactstrap";
import { ClipLoader } from 'react-spinners';
import {  history } from '_helpers';
import { notificationMessageActions, registerActions } from "_actions"
import { config } from '_constants';


import { hmpgTmplActions } from '_actions';
class CreatorWebsitesRedirect extends React.Component {
  constructor(props) {
    super(props);
    const username = props.match.params.username
    this.state = {
        // sp_id: props.match.params.id ? reverseNumberFunction(parseInt(props.match.params.id, 10)) :  props.location.state.sp_id, 
        username: username, 
      };
      this.redirectToDashboard = this.redirectToDashboard.bind(this);
    this.getMemberId() 
  }

    componentDidMount() {
    console.log("Redirect Props", this.props)
  }

  componentDidUpdate(prevProps) {
  const prevUsername = prevProps.match.params.username;
  const currentUsername = this.props.match.params.username;

  if (prevUsername !== currentUsername) {
    this.getMemberId();
  }
}



    getMemberId() {
    const { dispatch } = this.props
    const { username } = this.state

    dispatch(hmpgTmplActions.getMemberId({username: username}, (success, data) => {
      if (success) {
          this.setState({
            sp_id: parseInt(data, 10)
          })
        this.completeInitialSetup()
      } else {
        this.setState({
          sp_id: false, 
        })  
      }
    }));
    
  }

    completeInitialSetup() {
    console.log("Talent Home componentDidMount", this.props, window)
    const { sp_id, username } = this.state;
    const { dispatch } = this.props;

    if (!sp_id) {
        this.redirectToDashboard()
    } else {
      const creatorURL = `${config.creatorPortal}/c/${username}`;
        console.log("creatorURL", creatorURL)
      // Step 4: Open app via Universal Link
      window.location.replace(creatorURL);
    }
  }

    redirectToDashboard() {
      const { fanMode } = this.props 
      const user = JSON.parse(localStorage.getItem('user')); 
  
      // const loggedIn = user && user.hasOwnProperty('email');
      const userIsAgencyAsClient = user && user.agency_as_client;
      const userIsSpecialist = user && user.is_specialist;
      const userIsBusiness = user && user.is_business;
      const userIsUser = user && user.is_user
      const userIsAgency = user && user.is_agency
      if (user) {
        this.props.dispatch(notificationMessageActions.addNotificationToQueue("That creator URL is invalid.", 2))
        if (userIsUser || fanMode) {
          history.replace('/dash/user-dashboard')
        } else if (userIsAgencyAsClient) {
          history.replace('/dash/celeb-dashboard')
    
        } else if (userIsSpecialist && !fanMode) {
          history.replace('/dash/celeb-dashboard')
    
        } else if (userIsBusiness && !fanMode) {
          history.replace('/dash/business-dashboard')
    
        } else if (userIsAgency  && !fanMode) {
          history.replace('/dash/agency-dashboard')
    
        } else {
          history.replace('/auth/logout')
          console.log("could not redirect")
        }    
      } else {
        history.replace('/auth/logout')
        console.log("could not redirect")
      }
    }

  


  render() {

    const { claimRequest } = this.props;
    const { showMobileWarning } = this.state;

    return (
    <div className="content">
        {/* <div className="bg-dark py-8">
          <div className="text-center py-8"> 
              <h4 className="text-uppercase ls-1 text-white pb-3">
                Loading&nbsp;&nbsp;
              </h4>
              <div className='sweet-loading'>
                <ClipLoader
                  sizeUnit={"px"}
                  size={45}
                  color={'#ffffff'}
                  
                />
              </div> 
            </div> 
        </div> */}
      </div>    
      );
  }

  
}



function mapStateToProps(state) {
  const {  recsData, fanModeData} = state;
  const { claimRequest } = recsData;
  const { fanMode } = fanModeData;

  return {      

  };
}

const connectedCreatorWebsitesRedirect = connect(mapStateToProps)(CreatorWebsitesRedirect);
export { connectedCreatorWebsitesRedirect as CreatorWebsitesRedirect }; 